"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.flow = void 0;
exports.mapInitialStateToStoreState = mapInitialStateToStoreState;
var _mobx = require("mobx");
var _omit2 = _interopRequireDefault(require("lodash/omit"));
/**
 * map initial state for as store to store state
 * @param {Object} store
 * @param {Object} initialState
 */
function mapInitialStateToStoreState(store, initialState) {
  var storeInitialState = (0, _omit2["default"])(initialState, '$env');
  Object.keys(storeInitialState).forEach(function (key) {
    store[key] = storeInitialState[key];
  });
}

/**
 * @description mobx flow with correct yield types
 */
var flow = exports.flow = _mobx.flow;